import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectGroupComponent } from './select-group.component';

@NgModule({
  declarations: [
    SelectGroupComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    SelectGroupComponent
  ]
})
export class SelectGroupModule { }
